import React from "react";
import { Heart, MapPin, Wrench, Users } from "lucide-react";

const values = [
  {
    icon: Heart,
    title: "Down-to-earth service",
    desc: "We show up. We treat your project like it's our own.",
  },
  {
    icon: MapPin,
    title: "Locally rooted",
    desc: "Born in Kentucky, working everywhere. We know small business because we are one.",
  },
  {
    icon: Wrench,
    title: "Built to last",
    desc: "No trendy shortcuts. Code and systems engineered to run for years, not a season.",
  },
  {
    icon: Users,
    title: "Real partnership",
    desc: "You talk to the people building it. No account managers, no middlemen.",
  },
];

export default function About() {
  return (
    <section id="about" className="relative py-16 sm:py-32">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 lg:gap-20 items-center">
          <div>
            <span className="text-xs font-semibold tracking-[0.2em] uppercase text-accent/80">
              Our Story
            </span>
            <h2 className="mt-4 font-heading font-extrabold text-4xl sm:text-5xl text-foreground text-balance">
              A Kentucky web design studio that talks like a neighbor and builds like an engineer.
            </h2>
            <p className="mt-6 text-lg text-foreground/70 leading-relaxed">
              Bluegrass Web Works started with a simple idea: small businesses
              deserve the same caliber of tech the big guys get — without the
              big-guy price tag or the big-guy runaround. We're a small team
              that knows small business because we are one.
            </p>
            <p className="mt-4 text-foreground/70 leading-relaxed">
              We talk like your neighbor, not a marketing department. No
              handoffs, no jargon — just an honest build that works as hard as
              your business does.
            </p>

            <div className="mt-10 flex flex-wrap gap-3">
              <a
                href="#contact"
                className="px-6 py-3 rounded-full bg-accent text-accent-foreground font-semibold hover:bg-accent/90 transition-colors"
              >
                Contact Us
              </a>
              <a
                href="#portfolio"
                className="px-6 py-3 rounded-full border border-accent/30 text-accent font-semibold hover:bg-accent/5 transition-colors"
              >
                See our work
              </a>
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
            {values.map((v) => {
              const Icon = v.icon;
              return (
                <div
                  key={v.title}
                  className="p-6 rounded-[1.5rem] bg-card border border-border/70 hover:border-accent/30 transition-colors"
                >
                  <div className="w-11 h-11 rounded-2xl bg-accent/10 text-accent ring-1 ring-chart-3/20 flex items-center justify-center mb-4">
                    <Icon size={20} />
                  </div>
                  <h3 className="font-heading font-bold text-lg text-foreground">
                    {v.title}
                  </h3>
                  <p className="mt-2 text-sm text-foreground/70 leading-relaxed">
                    {v.desc}
                  </p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}